import Vue from 'vue'
import Router from 'vue-router'
import PortalLayout from '@/layout/PortalLayout.vue'
import { isAuthenticated } from '@/utils/auth'

Vue.use(Router)

const routes = [
  {
    path: '/',
    component: PortalLayout,
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('@/views/HomePage.vue'),
        meta: {
          title: '首页'
        }
      },
      {
        path: 'scores',
        name: 'ScoreList',
        component: () => import('@/views/ScoreListPage.vue'),
        meta: {
          title: '成绩列表',
          requiresAuth: true
        }
      },
      {
        path: 'scores/:candidateId',
        name: 'ScoreDetail',
        component: () => import('@/views/ScoreDetailPage.vue'),
        meta: {
          title: '成绩详情',
          requiresAuth: true
        }
      },
      {
        path: 'certificate/:certNo',
        name: 'CertificateDetail',
        component: () => import('@/views/CertificateDetailPage.vue'),
        meta: {
          title: '证书查询'
        }
      }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new Router({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta && record.meta.requiresAuth) && !isAuthenticated()) {
    next({
      path: '/',
      query: {
        redirect: to.fullPath
      }
    })
    return
  }

  next()
})

router.afterEach((to) => {
  const pageTitle = to.meta && to.meta.title
    ? `${to.meta.title} - 全国社会艺术水平等级考试`
    : '全国社会艺术水平等级考试'
  document.title = pageTitle
})

export default router
